module.exports = __webpack_public_path__ + "static/periyodik-bakim-99c50c5148b4ce865ad7e5f99b5d317b.jpg";